import logger from '../../utils/logger';
import React, { useState } from "react";
import { toast } from "react-toastify";
import "../../style/ImagingModals.css";

const labTests = [
  //ensure all labs are included, as we are missing some.
  // { code: "82024", name: "Adrenocorticotropic hormone (ACTH) level", type: "Blood" },
  // { code: "80105", name: "Alpha-fetoprotein (AFP) level, serum", type: "Blood" },
  // { code: "82150", name: "Amylase", type: "Blood" },
  // { code: "80048", name: "Basic Metabolic Panel", type: "Blood" },
  // { code: "87040", name: "Blood Culture", type: "Blood" },
  // { code: "85004", name: "Blood count; automated differential WBC count", type: "Blood" },
  // { code: "85027", name: "Blood count; complete (CBC), automated", type: "Blood" },
  { code: "85025", name: "Blood count; complete (CBC) with automated differential", type: "Blood" },
  // { code: "85014", name: "Blood count; hematocrit (Hct)", type: "Blood" },
  // { code: "85018", name: "Blood count; hemoglobin (Hgb)", type: "Blood" },
  // { code: "85048", name: "Blood count; leukocyte (WBC), automated", type: "Blood" },
  // { code: "85013", name: "Blood count; spun microhematocrit", type: "Blood" },
  // { code: "85049", name: "Blood count; platelet, automated", type: "Blood" },
  // { code: "85041", name: "Blood count; red blood cell (RBC), automated", type: "Blood" },
  // { code: "85060", name: "Blood smear, peripheral, interpretation", type: "Blood" },
  // { code: "86301", name: "CA 19-9 tumor antigen", type: "Blood" },
  // { code: "86304", name: "CA 125 tumor antigen", type: "Blood" },
  // { code: "84681", name: "C-Peptide", type: "Blood" },
  // { code: "89051", name: "Cell count, miscellaneous body fluids with differential", type: "Blood" },
  // { code: "80053", name: "Comprehensive Metabolic Panel", type: "Blood" },
  // { code: "82533", name: "Cortisol (hormone) measurement, total", type: "Blood" },
  // { code: "82553", name: "Creatine kinase (cardiac enzyme) level, MB fraction only", type: "Blood" },
  // { code: "82627", name: "Dehydroepiandrosterone (DHEA-S) hormone level", type: "Blood" },
  { code: "82670", name: "Estradiol (E2)", type: "Blood" },
  // { code: "82728", name: "Ferritin (blood protein) level", type: "Blood" },
  // { code: "82746", name: "Folic acid level, serum", type: "Blood" },
  // { code: "82747", name: "Folic acid level, RBC", type: "Blood" },
  // { code: "82977", name: "Gamma-glutamyl transferase (GGT)", type: "Blood" },
  { code: "83001", name: "Gonadotropin, follicle stimulating (FSH)", type: "Blood" },
  // { code: "84702", name: "Gonadotropin, chorionic (hCG), quantitative", type: "Blood" },
  { code: "83002", name: "Gonadotropin, luteinizing (LH)", type: "Blood" },
  // { code: "83037", name: "Hemoglobin A1C level", type: "Blood" },
  // { code: "80076", name: "Hepatic Function Panel (LFT)", type: "Blood" },
  // { code: "83090", name: "Homocysteine (amino acid) level", type: "Blood" },
  // { code: "83003", name: "Human growth hormone level", type: "Blood" },
  // { code: "82785", name: "IgE (immune system protein) level", type: "Blood" },
  // { code: "83525", n82962ame: "Insulin measurement, total", type: "Blood" },
  // { code: "80069", name: "Metlyte 8 Panel (Renal Panel)", type: "Blood" },
  // { code: "83874", name: "Myoglobin (muscle protein) level", type: "Blood" },
  // { code: "83880", name: "Natriuretic peptide (BNP)", type: "Blood" },
  // { code: "83970", name: "Parathormone (parathyroid hormone) level", type: "Blood" },
  // { code: "84066", name: "Phosphatase, prostatic (prostate enzyme) level", type: "Blood" },
  { code: "84144", name: "Progesterone (reproductive hormone) level", type: "Blood" },
  // { code: "84146", name: "Prolactin (milk producing hormone) level", type: "Blood" },
  // { code: "84153", name: "PSA (prostate specific antigen) measurement, total", type: "Blood" },
  // { code: "84270", name: "Sex hormone binding globulin (SHBG)", type: "Blood" },
  // { code: "84403", name: "Testosterone (hormone) level, total", type: "Blood" },
  // { code: "84436", name: "Thyroxine (T4), total", type: "Blood" },
  { code: "84439", name: "Thyroxine (T4), free", type: "Blood" },
  { code: "84481", name: "Triiodothyronine (T3), free", type: "Blood" },
  { code: "84443", name: "Thyroid stimulating hormone (TSH)", type: "Blood" },
  // { code: "84480", name: "Thyroid hormone, T3 measurement, total", type: "Blood" },
  // { code: "84481", name: "Thyroid hormone, T3 measurement, free", type: "Blood" },
  // { code: "84484", name: "Troponin (protein) level", type: "Blood" },
  // { code: "84550", name: "Uric acid", type: "Blood" },
  // { code: "82607", name: "Vitamin B12 level", type: "Blood" },
  // { code: "82306", name: "Vitamin D-3 level", type: "Blood" },
  { code: "84702", name: "Quantitative Beta HCG", type: "Blood" },
  { code: "82962", name: "Glucose (Blood)", type: "Blood" },
  // { code: "85730", name: "Thromboplastin time (PTT), partial", type: "Blood" },
  // { code: "85610", name: "Prothrombin time (PT)", type: "Blood" },
  // { code: "82947", name: "Glucose", type: "Finger Stick" },
  // { code: "87804", name: "Influenza A and B", type: "Nasal" },
  // { code: "87807", name: "RSV Antigen Test", type: "Nasal" },
  // { code: "87635", name: "Rapid COVID-19 Test", type: "Nasal" },
  // { code: "87880", name: "Rapid Strep Test", type: "Throat" },
  // { code: "86689", name: "Monospot Test", type: "Throat" },
  // { code: "81003", name: "Urinalysis, Automated", type: "Urine" },
  // { code: "87081", name: "Urine Culture", type: "Urine" },
  // { code: "80305", name: "Urine Drug Screen", type: "Urine" },
  // { code: "80310", name: "Urine Pregnancy Test", type: "Urine" },
  // { code: "82270", name: "Fecal Occult Blood Test (Guaiac-based)", type: "Stool" },
//   { code: "82274", name: "Fecal Immunochemical Test (FIT)", type: "Stool" },
//   { code: "87046", name: "Stool Culture", type: "Stool" },
//   { code: "87177", name: "Ova and Parasites Exam", type: "Stool" },
//   { code: "87493", name: "C. difficile (PCR)", type: "Stool" },
//   { code: "87338", name: "H. pylori Antigen", type: "Stool" },
//   { code: "83993", name: "Calprotectin, Fecal", type: "Stool" },
//   { code: "82710", name: "Fecal Fat, Quantitative", type: "Stool" },
];


// const labTypes = ["Blood", "EKG", "Urine", "Nasal", "Throat", "Stool", "Finger Stick"];
const labTypes = ["Blood"]; // "Urine", "Nasal", "Throat", "Stool", "Finger Stick"

const LAB_PROFILES = [
  { code: "80053", name: "Comprehensive Metabolic Panel" },
  { code: "80076", name: "Hepatic Function Panel" },
  { code: "84443", name: "TSH with reflex T4, Free T3 Total if Abnormal" },
];

const initialState = {
  firstName: "",
  lastName: "",
  dob: "",
  sex: "",
  orderingClinician: "",
  diagnosis: "",
  specimenDate: "",
  specimenTime: "",
  drawnBy: "",
  fasting: "",
  selectedProfiles: [],
  selectedTests: [],
  priority: "STAT",
  notes: "",
};

const QuickLabOrderModal = ({ isOpen, onClose }) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [form, setForm] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Patient search state
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  if (!isOpen) return null;

  const set = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const toggleItem = (field, item) => {
    setForm((prev) => {
      const already = prev[field].some((i) => i.name === item.name);
      return {
        ...prev,
        [field]: already
          ? prev[field].filter((i) => i.name !== item.name)
          : [...prev[field], { name: item.name, code: item.code }],
      };
    });
  };

  const resetForm = () => {
    setForm(initialState);
    setSearchQuery('');
    setSearchResults([]);
    setSelectedPatient(null);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSearch = async (query) => {
    if (!query.trim()) { setSearchResults([]); return; }
    setIsSearching(true);
    try {
      const response = await fetch(`${BASE_URL}/ris/search?pat=${encodeURIComponent(query)}`);
      if (response.ok) setSearchResults(await response.json());
      else setSearchResults([]);
    } catch {
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);
    setSearchResults([]);
    setSearchQuery('');
    setForm(prev => ({
      ...prev,
      firstName: patient.first_name || '',
      lastName: patient.last_name || '',
      dob: patient.dob || '',
      sex: patient.sex || '',
    }));
  };

  const handleClearPatient = () => {
    setSelectedPatient(null);
    setForm(prev => ({ ...prev, firstName: '', lastName: '', dob: '', sex: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.firstName.trim()) {
      toast.warning("Please enter the patient first name");
      return;
    }
    if (!form.lastName.trim()) {
      toast.warning("Please enter the patient last name");
      return;
    }
    if (!form.dob) {
      toast.warning("Please enter the date of birth");
      return;
    }
    if (!form.sex) {
      toast.warning("Please select the patient sex");
      return;
    }
    if (!form.orderingClinician.trim()) {
      toast.warning("Please enter the ordering clinician");
      return;
    }
    if (!form.diagnosis.trim()) {
      toast.warning("Please enter the diagnosis");
      return;
    }
    if (form.selectedProfiles.length === 0 && form.selectedTests.length === 0) {
      toast.warning("Please select at least one profile or lab test");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${BASE_URL}/labs/referral`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ris_patients_id: selectedPatient?.ris_patients_id || null,
          first_name: form.firstName.trim(),
          last_name: form.lastName.trim(),
          dob: form.dob,
          sex: form.sex,
          ordering_clinician: form.orderingClinician.trim(),
          diagnosis: form.diagnosis.trim(),
          specimen_date: form.specimenDate || null,
          specimen_time: form.specimenTime || null,
          drawn_by: form.drawnBy.trim() || null,
          fasting: form.fasting || null,
          selected_profiles: form.selectedProfiles,
          selected_tests: form.selectedTests,
          priority: form.priority,
          notes: form.notes.trim() || null,
        }),
      });

      const contentType = response.headers.get("content-type");
      const data = contentType?.includes("application/json")
        ? await response.json()
        : { msg: await response.text() };

      if (response.ok) {
        toast.success(data.msg || "Lab order submitted successfully!");
        resetForm();
        onClose();
      } else {
        toast.error(data.msg || "Failed to submit lab order");
      }
    } catch (error) {
      logger.error("Error submitting lab order:", error);
      toast.error("Error submitting lab order. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const activeTests = labTests.filter(t => !t.disabled);

  return (
    <div className="im-modal-overlay" onClick={handleClose}>
      <div
        className="im-modal-content"
        style={{ maxWidth: "620px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="im-modal-header">
          <h3>Quick Lab Order</h3>
          <button className="im-modal-close" onClick={handleClose} disabled={isSubmitting}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="im-modal-body">

            {/* ── Patient Search ── */}
            <p className="im-section-label">Returning Patient Search</p>
            {selectedPatient ? (
              <div className="im-selected-patient-banner">
                <span><strong>{selectedPatient.first_name} {selectedPatient.last_name}</strong> &mdash; DOB: {selectedPatient.dob}</span>
                <button type="button" className="im-selected-patient-clear" onClick={handleClearPatient} title="Clear patient selection">&times;</button>
              </div>
            ) : (
              <div className="im-search-wrapper">
                <div className="im-search-row">
                  <input
                    type="text"
                    className="im-input"
                    placeholder="Search by name, DOB, or address…"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), handleSearch(searchQuery))}
                    disabled={isSubmitting}
                  />
                  <button
                    type="button"
                    className="im-btn-secondary"
                    onClick={() => handleSearch(searchQuery)}
                    disabled={isSubmitting || isSearching}
                  >
                    {isSearching ? 'Searching…' : 'Search'}
                  </button>
                </div>
                {searchResults.length > 0 && (
                  <div className="im-search-dropdown">
                    {searchResults.map((p) => (
                      <div
                        key={p.ris_patients_id}
                        className="im-search-result-item"
                        onClick={() => handleSelectPatient(p)}
                      >
                        <strong>{p.first_name} {p.last_name}</strong> &mdash; {p.dob} &mdash; {p.street_number} {p.street_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ── Patient Information ── */}
            <p className="im-section-label">Patient Information</p>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              <div className="im-form-group">
                <label htmlFor="qlo-first-name">
                  First Name <span className="im-required">*</span>
                </label>
                <input
                  id="qlo-first-name"
                  type="text"
                  className="im-input"
                  placeholder="First name"
                  value={form.firstName}
                  onChange={set("firstName")}
                  disabled={isSubmitting || !!selectedPatient}
                />
              </div>
              <div className="im-form-group">
                <label htmlFor="qlo-last-name">
                  Last Name <span className="im-required">*</span>
                </label>
                <input
                  id="qlo-last-name"
                  type="text"
                  className="im-input"
                  placeholder="Last name"
                  value={form.lastName}
                  onChange={set("lastName")}
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              <div className="im-form-group">
                <label htmlFor="qlo-dob">
                  Date of Birth <span className="im-required">*</span>
                </label>
                <input
                  id="qlo-dob"
                  type="date"
                  className="im-input"
                  value={form.dob}
                  onChange={set("dob")}
                  disabled={isSubmitting}
                />
              </div>

              <div className="im-form-group">
                <label htmlFor="qlo-sex">
                  Sex <span className="im-required">*</span>
                </label>
                <select
                  id="qlo-sex"
                  className="im-select"
                  value={form.sex}
                  onChange={set("sex")}
                  disabled={isSubmitting}
                >
                  <option value="">Select Sex</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
            </div>

            <div className="im-form-group">
              <label htmlFor="qlo-clinician">
                Ordering Clinician <span className="im-required">*</span>
              </label>
              <input
                id="qlo-clinician"
                type="text"
                className="im-input"
                placeholder="Dr. First Last"
                value={form.orderingClinician}
                onChange={set("orderingClinician")}
                disabled={isSubmitting}
              />
            </div>

            <div className="im-form-group">
              <label htmlFor="qlo-diagnosis">
                Diagnosis <span className="im-required">*</span>
              </label>
              <input
                id="qlo-diagnosis"
                type="text"
                className="im-input"
                placeholder="Diagnosis code / description"
                value={form.diagnosis}
                onChange={set("diagnosis")}
                disabled={isSubmitting}
              />
            </div>

            {/* ── Specimen Information ── */}
            <p className="im-section-label">
              Specimen Information
            </p>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              <div className="im-form-group">
                <label htmlFor="qlo-spec-date">Specimen Date</label>
                <input
                  id="qlo-spec-date"
                  type="date"
                  className="im-input"
                  value={form.specimenDate}
                  onChange={set("specimenDate")}
                  disabled={isSubmitting}
                />
              </div>
              <div className="im-form-group">
                <label htmlFor="qlo-spec-time">Specimen Time</label>
                <input
                  id="qlo-spec-time"
                  type="time"
                  className="im-input"
                  value={form.specimenTime}
                  onChange={set("specimenTime")}
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              <div className="im-form-group">
                <label htmlFor="qlo-drawn-by">Drawn By</label>
                <input
                  id="qlo-drawn-by"
                  type="text"
                  className="im-input"
                  placeholder="Staff name"
                  value={form.drawnBy}
                  onChange={set("drawnBy")}
                  disabled={isSubmitting}
                />
              </div>
              <div className="im-form-group">
                <label htmlFor="qlo-fasting">Fasting Specimen</label>
                <select
                  id="qlo-fasting"
                  className="im-select"
                  value={form.fasting}
                  onChange={set("fasting")}
                  disabled={isSubmitting}
                >
                  <option value="">Select…</option>
                  <option value="YES">Yes</option>
                  <option value="NO">No</option>
                </select>
              </div>
            </div>

            {/* ── Lab Information ── */}
            <p className="im-section-label">
              Lab Information
            </p>

            {/* Profiles */}
            <div className="im-form-group">
              <label>
                Profiles{" "}
                {form.selectedProfiles.length > 0 && (
                  <span style={{ color: "#2563eb", fontWeight: 600 }}>({form.selectedProfiles.length} selected)</span>
                )}
              </label>
              <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "4px" }}>
                {LAB_PROFILES.map((profile) => (
                  <label
                    key={profile.code}
                    style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "0.875rem", fontWeight: 400, cursor: "pointer" }}
                  >
                    <input
                      type="checkbox"
                      checked={form.selectedProfiles.some((p) => p.name === profile.name)}
                      onChange={() => toggleItem("selectedProfiles", profile)}
                      disabled={isSubmitting}
                      style={{ width: "15px", height: "15px", cursor: "pointer" }}
                    />
                    {profile.name}
                  </label>
                ))}
              </div>
            </div>

            {/* Individual Tests */}
            <div className="im-form-group">
              <label>
                Tests{" "}
                {form.selectedTests.length > 0 && (
                  <span style={{ color: "#2563eb", fontWeight: 600 }}>({form.selectedTests.length} selected)</span>
                )}
              </label>
              <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "4px" }}>
                {activeTests.map((test) => (
                  <label
                    key={test.code}
                    style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "0.875rem", fontWeight: 400, cursor: "pointer" }}
                  >
                    <input
                      type="checkbox"
                      checked={form.selectedTests.some((t) => t.name === test.name)}
                      onChange={() => toggleItem("selectedTests", test)}
                      disabled={isSubmitting}
                      style={{ width: "15px", height: "15px", cursor: "pointer" }}
                    />
                    {test.name}
                    <span style={{ color: "#9ca3af", fontSize: "0.8rem" }}>— {test.code}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="im-form-group">
              <label htmlFor="qlo-priority">Priority</label>
              <select
                id="qlo-priority"
                className="im-select"
                value={form.priority}
                onChange={set("priority")}
                disabled={isSubmitting}
              >
                <option value="STAT">STAT</option>
                <option value="Routine">Routine</option>
              </select>
            </div>

            <div className="im-form-group">
              <label htmlFor="qlo-notes">
                Notes <span className="im-optional">(optional)</span>
              </label>
              <textarea
                id="qlo-notes"
                className="im-textarea"
                rows={3}
                placeholder="Additional notes or clinical context..."
                value={form.notes}
                onChange={set("notes")}
                disabled={isSubmitting}
              />
            </div>
          </div>

          <div className="im-modal-footer">
            <button
              type="button"
              className="im-btn-secondary"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="im-btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting
              ? "Submitting..."
              : `Submit Lab Order${form.selectedProfiles.length + form.selectedTests.length > 0 ? ` (${form.selectedProfiles.length + form.selectedTests.length} item${form.selectedProfiles.length + form.selectedTests.length > 1 ? "s" : ""})` : ""}`
            }
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuickLabOrderModal;
